<template>
  <div class="main">
    <div class="pz" v-show="resultFlag == 0">
      <div class="take" v-show="flag == 0">
        <div class="select">
          <img :src="page.photoImgUrl" alt />
          <input type="file" id="file" name="image" accept="image/*" capture="camera" @change="take" />
        </div>
        <!-- <template v-for="(p, key) in links">
          <p style="text-align: center; margin-top: 5px; font-size: 0.5rem" :key="key" v-if="p.key == 1">
            {{ p.value }}
          </p>
        </template> -->
      </div>
      <div class="wait" v-show="flag == 1">
        <p style="font-size: 0.56rem">上传中...</p>
        <img style="width: 4rem" src="../../assets/images/example02/wait.gif" alt />
      </div>
    </div>

    <canvas width height ref="myCanvas" class="hidden"></canvas>
  </div>
</template>

<script>
import { listH5Pages } from '@/api/h5Pages'
import { getH5Applet, listH5Applet } from '@/api/h5Applet'
import { getDatabaseIsExits, listKHttpCode } from '@/api/kHttpCode'

import axios from 'axios'
import applet from '../../store/modules/applet';
export default {
  props: {
    applet: {
      type: Object,
      default() {
        return {}
      }
    },
    page: {
      type: Object,
      default() {
        return {}
      }
    },
    links: {
      type: Array,
      default() {
        return []
      }
    },
    pageInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data: () => {
    return {
      flag: 0,
      resultFlag: 0,
      currentFlag: 0,
      webpath: 'http://b.kesiyuan.com/WeCat/home/artificialCompareImg',
      // webpath: '/WeCat/home/artificialCompareImg',
      addrssx: '北京市北京市',
      adcode: '110100',
      antiCompany: '',
      rengongqun: [],
      webpathz: 'http://b.kesiyuan.com/WeCat',
      // webpathz: '/WeCat',
      user: {},
      mimc_appId: '2882303761517644081',
      mimc_appSecret: 'RWm2RxELBLPJmP7+6ESl1Q==',
      mimc_appKey: '5881764490081',
      mimc_appAccount: '',
      mimc_inter: false,
      pages: [],
      isXWOrWL: 0,
      otherCodes: {
        'http://weixin.qq.com/r/EzgAGKjEkvXtrex7920B01146703121': ['http://oss.ksy7.cn/818109存档.jpg', 'http://oss.ksy7.cn/818109手机.jpg'],
        'http://weixin.qq.com/r/EzgAGKjEkvXtrex7920B01146702946': ['http://oss.ksy7.cn/255203存档.jpg', 'http://oss.ksy7.cn/255203手机.jpg'],
        'http://weixin.qq.com/r/EzgAGKjEkvXtrex7920B01146703309': ['http://oss.ksy7.cn/906007存档.png', 'http://oss.ksy7.cn/906007手机.jpg'],
        'http://weixin.qq.com/r/EzgAGKjEkvXtrex7920B01146703005': ['http://oss.ksy7.cn/757533存档.png', 'http://oss.ksy7.cn/757533手机.jpg'],
      },
      otherCodes2: {
        'http://weixin.qq.com/r/EzgAGKjEkvXtrex7920B01146702884': ['http://oss.ksy7.cn/818109存档.jpg', 'http://oss.ksy7.cn/818109手机.jpg'],
      }
    }
  },
  created() {
    var index = new Date().getMilliseconds();
    this.mimc_appAccount = TEMPUSERS[index];
    console.log(this.page, this.applet, this.links)
    axios.get(this.webpathz + '/login/getloginUser').then(({ data, status }) => {
      this.rengongqun = data.data
      this.login()
    })
    listH5Pages({ appletId: this.applet.appletId }).then(res => {
      this.pages = res.data
    })

  },
  methods: {
    //小米云通讯
    fetchMIMCToken: function () {
      var that = this;
      var sendData = { appId: that.mimc_appId, appKey: that.mimc_appKey, appSecret: that.mimc_appSecret, appAccount: that.mimc_appAccount };
      console.log(sendData)
      return that.httpRequest('https://mimc.chat.xiaomi.net/api/account/token', sendData);
    },
    httpRequest: function (url, data) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url, false);
      xhr.setRequestHeader('content-type', 'application/json');
      xhr.send(JSON.stringify(data));
      console.log(xhr.response)
      return JSON.parse(xhr.response);
    },
    take: function () {
      var that = this;
      this.flag = 1;
      //是否支持canvas
      var _canvas = this.$refs.myCanvas;
      console.log(_canvas);
      if (!_canvas.getContext) {
        console.log(1)
        //将图片保存
        //that.paishetest();
        return;
      } else {
        console.log(2)
        that.paishetest1();
      }
    },
    paishetest: function () {//无canvas提交
      var that = this;
      var currentTime = (new Date()).getTime();
      var fileidNum = '' + currentTime + Math.floor(Math.random() * 10);
      // store.set('yanweiTime', currentTime);
      //原url："/ksy/home/compareImg" //人工url："/ksy/home/artificialCompareImg"
      $.ajaxFileUpload({
        url: that.webpath,//+ "/home/artificialCompareImg",
        secureuri: false,
        timeout: 30000,
        data: {
          fileid: fileidNum,
          addrssx: that.addrssx,
          adcode: that.adcode,
          company: that.antiCompany //蜜蜂在线为1
        },//需要传递的数据 json格式
        fileElementId: ['file'],
        dataType: "text",
        success: function (res) { // data 保存提交后返回的数据，一般为 json 数据
          //1  二维码解析失败   2 工业图不存在  3判真   4 判假
          console.log(res);
          //that.successCallback(res);
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
          that.src1 = ""
          if (textStatus == "timeout") {
            weui.topTips("请求超时", 3000);
          } else {
            if (!navigator.onLine) {
              weui.topTips("网络连接失败，请检查网络后重试", 3000);
            }
          }

        },
        complete: function (XHR, TS) {
          XHR = null;//内存回收
        }
      });

    },
    paishetest1: function () {//有canvas提交
      var that = this;
      //原url："/ksy/home/compareImg" //人工url："/ksy/home/artificialCompareImg"
      console.log(this.$route.query)
      that.basetoBlob(function (fd) {
        // http://39.98.50.243:9300/api/qr/identifyImg
        $.ajax({
          type: 'POST',
          // url: process.env.VUE_APP_BASE_API + "/system/productlabelimage/qr",//+ "/home/artificialCompareImg",
          url: process.env.VUE_APP_QR_API + '/api/qr/identifyImg',
          data: fd,
          dataType: "json",
          timeout: 30000,
          processData: false, // 不会将 data 参数序列化字符串
          contentType: false // 根据表单 input 提交的数据使用其默认的 contentType
        }).success(async function (_res) {
          if (that.page.key == 11) {
            setTimeout(() => {
              window.location.href = _res.data.qr
              console.log(document.href)
            }, 100);
            return
          }
          console.log('xxxx', _res)
          _res.data.fullPath = 'http://ksy7.cn/imgs/' + _res.data.fullPath
          if (_res.data.result == 1 || _res.data.result == 0) {
            if (_res.data.result == 0) {
              console.log(that.$route.query)
              _res.data.qr = that.$route.query.url
            }
            let qr_res = await listKHttpCode({ pageNum: 1, pageSize: 1, http: _res.data.qr })
            if (qr_res.rows.length > 0) {

              let _kHttpCode = qr_res.rows.length > 0 ? qr_res.rows[0] : {}
              let _data = { "status": { "code": "4", "msg": "判真！" }, "data": { "fullPath": "/group1/M00/A0/2F/Ch-a62kUXd-AX_-gAARN0LmSJwA461.jpg", "qr": "", "productName": "柯斯样标Q2", "yourWl": ["/group1/M00/A0/2F/Ch-a62kUXd-AJO06AAAoNTucMtU688.jpg"], "myWl": ["/group1/M00/A0/2F/Ch-a62kUXd-Aa8t1AAAdDfrLgMw869.jpg"], "yourQrAndWl": "/group1/M00/A0/2F/Ch-a62kUXd-AWCRZAABn-wu7S3k763.jpg", "myQrAndWl": "/group1/M00/A0/2F/Ch-a62kUXd-AUgsfAABBQIntkB0806.jpg", "productLogo": "/group1/M00/A0/2F/Ch-a62kUXd-AfFcWAAB_wVa2O1U505.jpg", "productImgPath": "/group1/M00/A0/2F/Ch-a62kUXd-AekmmAAGTfbVwV_c596.jpg", "rate": 54, "type": 0, "addrssx": "北京市北京市", "adcode": "110100", "baseRate": 30, "showVideoPath": "", "showImgPath": "", "showGifPath": "", "videoType": "5", "qrScanningCount": 187 } };
              _data.data.qr = _res.data.qr
              that.isXWOrWL = 1
              that.applet.judgeModel = 2
              _data.data.fullPath = _res.data.fullPath
              _data.data.myWl = [_kHttpCode.certificateImageUrl]
              _data.data.yourWl = [_res.data.fullPath]

              that.judgeModel(that, _data, _data.status.code)
            } else {
              qr_res = await getDatabaseIsExits({ qrurl: _res.data.qr })

              if (qr_res.rows.length > 0) {
                that.isXWOrWL = 2
                $.ajax({
                  type: 'POST',
                  url: that.webpath,//+ "/home/artificialCompareImg",
                  data: fd,
                  dataType: "json",
                  timeout: 30000,
                  processData: false, // 不会将 data 参数序列化字符串
                  contentType: false // 根据表单 input 提交的数据使用其默认的 contentType
                }).success(function (res) {
                  var code = res.status.code;

                  if (code == "2" || code == "3" || code == "4") {

                    if (res.data && res.data.qr && res.data.qr.indexOf('http://ksy7.cn/') > -1) {
                      let _qr = res.data.qr.replace('http://ksy7.cn/', '')
                      let _appletCode = _qr.slice(0, _qr.indexOf('/'))

                      if (_appletCode != that.applet.code) {
                        listH5Applet({ code: _appletCode }).then(_res => {
                          listH5Pages({ appletId: _res.rows[0].appletId }).then(__res => {
                            that.pages = __res.data
                            that.judgeModel(that, res, code)
                          })
                        })
                      } else {
                        that.judgeModel(that, res, code)
                      }
                    } else
                      that.judgeModel(that, res, code)
                  } else
                    that.judgeModel(that, res, code)
                })
              } else {
                that.compared({ data: _res.data }, "8")
              }
            }
            // console.log('awit', aw_res)
          } else {
            that.compared({ data: _res.data }, "7")
          }
        })
      })

    },
    judgeModel(that, res, code) {
      // console.log('7777' + that.applet.judgeModel + '-----' + code)
      if (code == "1") {
        // console.log(res, _res)
        that.compared({ data: res.data }, "7")
      }
      else if (code == "2")
        that.compared(res, "8")
      else if (code == "3") {
        // console.log('7777' + that.applet.judgeModel)
        if (that.applet.judgeModel == 2) {
          that.rengong(that, res)
          that.compared(res, "2")
        } else
          that.compared(res, "2")
      }
      else if (code == "4") {
        console.log('8888' + that.applet.judgeModel)
        //judgeModel: 1.消费者识别、不显示判定结果,2.后台人工识别,3.后台人工+自动,4.后台全自动
        if (that.applet.judgeModel == '1') {
          that.compared(res, "2")
        } else if (that.applet.judgeModel == '2' || that.applet.judgeModel == '3') {
          that.rengong(that, res)
          that.compared(res, "2")
        } else if (that.applet.judgeModel == '4') {
          that.compared(res, "2")
        }
      }
    },
    rengong(that, res) {
      var timeCount = that.downTotal;
      var intervalobj = setInterval(function () {
        if (that.fenBu) {//当判定结果返回时停止定时器
          clearInterval(intervalobj);
        }
        if (timeCount == 0) {//当判定结果一直没返回时，显示超时
          that.src1 = "images/yellow.png";
          that.fenBuClass = 'font_yellow';
          that.fenBuTxt = '无法判定';
          clearInterval(intervalobj);
          weui.alert('请求超时，请重新验证', function () {
            setTimeout(function () {
              that.again();
            }, 500)
          });
        }
        timeCount--;
        if (that.mimc_inter) {//当用户登录成功后才进行发送消息
          //              		that.videoType = res.data.videoType;
          for (var i = 0; i < that.rengongqun.length; i++) {//循环发给人工客服
            // console.log("------------------begin--------------------");
            // console.log(that.rengongqun[i].loginName, JSON.stringify(res.data))
            // console.log("------------------end--------------------");
            that.sendMsg(that.rengongqun[i].loginName, JSON.stringify(res.data))
          }
          that.mimc_inter = false;
          //clearInterval(intervalobj);
        }
      }, 1000)
    },
    compared(res, pageType) {
      let _key = new Date().getTime()
      console.log("KSY_RESULT_" + _key, pageType)
      sessionStorage.setItem("KSY_RESULT_" + _key, JSON.stringify(res.data))
      let _page = this.pages.find(item => { return item.pageType == pageType })
      this.$router.push({ path: '/main', query: { pageId: _page.pageId, key: _key } })
    },
    login() {
      var that = this;
      that.user = new MIMCUser(that.mimc_appId, that.mimc_appAccount);
      that.user.registerP2PMsgHandler(that.receiveP2PMsg);//接收单聊消息回调
      that.user.registerFetchToken(that.fetchMIMCToken);//获取token回调
      that.user.registerStatusChange(that.statusChange);//登录结果回调
      that.user.registerServerAckHandler(that.serverAck);//发送消息后，服务器接收到消息ack的回调
      that.user.registerDisconnHandler(that.disconnect);//连接断开回调
      that.user.login();
    },
    receiveP2PMsg(message) {//接收单聊消息回调  //N
      var that = this;
      var date = new Date(parseInt(message.getTimeStamp()));

      var disMsg = Base64;//new Base64();

      var msgData = JSON.parse(disMsg.decode(JSON.parse(message.getPayload()).content));

      //console.log(msgData);
      var iobj = {
        data: {
          createTime: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds(),
          fullPath: msgData.fullPath,
          myWl: msgData.myWl,
          yourWl: msgData.yourWl,
          myQrAndWl: msgData.myQrAndWl,
          yourQrAndWl: msgData.yourQrAndWl,
          productImgPath: msgData.productImgPath,
          productLogo: msgData.productLogo,
          productName: msgData.productName,
          qr: msgData.qr,
          qrScanningCount: msgData.qrScanningCount,
          description: msgData.des,
          rate: msgData.rate,
          baseRate: msgData.baseRate,
          type: msgData.type
        },
        status: {
          code: msgData.newCode
        }
      }
      that.wenliCode = msgData.newCode;
      that.fenBu = true;
      console.log('SET_JudgeResult', msgData.newCode)
      if (msgData.newCode == 1) {//
        that.src1 = "images/yellow.png";
        that.fenBuClass = 'font_yellow';
        that.fenBuTxt = '无法判定';
        that.flag2 = false;
        that.$store.commit('SET_JudgeResult', '不相符')
      } else if (msgData.newCode == 3) {//真
        that.src1 = "images/green.png";
        that.fenBuClass = 'font_blue';
        that.fenBuTxt = '通过';
        that.flag2 = false;
        that.$store.commit('SET_JudgeResult', '相符')
      } else if (msgData.newCode == 4) {
        that.src1 = "images/red.png";
        that.fenBuClass = 'font_red';
        that.fenBuTxt = '未通过';
        that.flag2 = false;
        that.$store.commit('SET_JudgeResult', '不相符')
      }
    },
    statusChange: function (bindResult, errType, errReason, errDesc) {//登录结果回调
      var that = this;
      if (bindResult) {
        that.mimc_inter = true;
        console.log("login succeed");
      } else {
        console.log("login failed.errReason=" + errReason + ",errDesc=" + errDesc + ",errType=" + errType);
      }
    },

    serverAck: function (packetId, sequence, timeStamp, errMsg) {//发送消息后，服务器接收到消息ack的回调
      //writeToScreens("receive msg ack:" + packetId + ",sequence=" + sequence + ",ts=" + timeStamp);
      return;
    },
    disconnect: function () {//连接断开回调
      var that = this;
      console.log("disconnect");
      that.login();
    },
    logout: function () {//退出登录
      var that = this;
      that.user.logout();
    },
    sendMsg: function (toUser, message) {//发送单人消息
      console.log('-------' + toUser + '--------');
      var that = this;

      var a = Base64;//new Base64();
      var message_ = a.encode(message);
      var jsonMsg = String(JSON.stringify({
        version: 0,
        msgId: "TEXT_1234",
        msgType: 103,
        timestamp: String((new Date()).valueOf()),
        payload: message_,
        content: message_
      }));

      try {
        // var packetId = that.user.sendMessage('example001', jsonMsg);
        var packetId = that.user.sendMessage(toUser, jsonMsg);
      } catch (err) {
        console.log("sendMessage fail, err=" + err);
      }
      //that.chats.push(that.mimc_appAccount + " to " + toUser + ":" + message);
    },
    changepic: function (callback) {
      var that = this;
      var reads = new FileReader();
      var images = new Image();
      var f = document.getElementById('file').files[0];
      var img64;
      reads.readAsDataURL(f);
      reads.onload = function (ev) {
        images.src = this.result;
        images.onload = function () {
          img64 = that.compress(images);
          //alert("图片的宽度为"+this.width+",长度为"+this.height);
          // var img64 = compress(images,500,400,0.7);
          return callback(img64);
        };
      }
    },
    compress: function (_img) {
      //2.计算符合目标尺寸宽高值，若上传图片的宽高都大于目标图，对目标图等比压缩；如果有一边小于，对上传图片等比放大。
      var _goalWidth = 1500,                  //目标宽度
        _goalHeight = 1500,                 //目标高度
        _imgWidth = _img.naturalWidth,     //图片宽度
        _imgHeight = _img.naturalHeight,   //图片高度
        _tempWidth = _imgWidth,            //放大或缩小后的临时宽度
        _tempHeight = _imgHeight,          //放大或缩小后的临时宽度
        _r = 1;                            //压缩比
      // alert('_tempWidth:'+_tempWidth+',_tempHeight:'+_tempHeight);


      if (_imgWidth === _goalWidth && _imgHeight === _goalHeight) {

      } else if (_imgWidth > _goalWidth && _imgHeight > _goalHeight) {//宽高都大于目标图，需等比压缩
        _r = _imgWidth / _goalWidth;
        if (_imgHeight / _goalHeight < _r) {
          _r = _imgHeight / _goalHeight;
        }
        _tempWidth = Math.ceil(_imgWidth / _r);
        _tempHeight = Math.ceil(_imgHeight / _r);
      } else {
        if (_imgWidth < _goalWidth && _imgHeight < _goalHeight) {//宽高都小于
          _r = _goalWidth / _imgWidth;
          if (_goalHeight / _imgHeight < _r) {
            _r = _goalHeight / _imgHeight;
          }
        } else {
          if (_imgWidth < _goalWidth) {         //宽小于
            _r = _goalWidth / _imgWidth;
          } else {                              //高小于
            _r = _goalHeight / _imgHeight;
          }
        }

        _tempWidth = Math.ceil(_imgWidth * _r);
        _tempHeight = Math.ceil(_imgHeight * _r);
      }


      //3.利用canvas对图片进行裁剪，等比放大或缩小后进行居中裁剪
      // var _canvas = e._$get('canvas-clip');
      // if(!_canvas.getContext) return;
      var _canvas = this.$refs.myCanvas;
      if (!_canvas.getContext) return;
      var _context = _canvas.getContext('2d');
      _canvas.width = _tempWidth;
      _canvas.height = _tempHeight;

      // alert('_imgWidth:'+_tempWidth+',_imgHeight:'+_tempHeight);
      _context.drawImage(_img, 0, 0, _tempWidth, _tempHeight);

      //toDataURL方法，可以获取格式为"data:image/png;base64,***"的base64图片信息；

      var _data = _canvas.toDataURL("image/jpeg");
      return _data;
    },
    basetoBlob: function (callback) {
      var that = this;
      that.changepic(function (_data) {

        //4.获取canvas中的图片信息
        //window.atob方法将其中的base64格式的图片转换成二进制字符串；若将转换后的值直接赋值给Blob会报错，需Uint8Array转换：最后创建Blob对象；
        _data = _data.split(',')[1];
        _data = window.atob(_data);
        //如果不用ArrayBuffer,发送给服务器的图片格式是[object Uint8Array],上传失败...
        var _buffer = new ArrayBuffer(_data.length);
        var _ubuffer = new Uint8Array(_buffer);
        for (var i = 0; i < _data.length; i++) {
          _ubuffer[i] = _data.charCodeAt(i);
        }
        // 安卓 UC浏览器不支持 new Blob()，使用BlobBuilder
        var _blob;
        try {
          _blob = new Blob([_buffer], { type: 'image/jpeg' });
        } catch (ee) {
          window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
          if (ee.name == 'TypeError' && window.BlobBuilder) {
            var _bb = new BlobBuilder();
            _bb.append(_buffer);
            _blob = _bb.getBlob('image/jpeg');
          }
        }

        var _suffix = 'jpg';
        if (_blob.type === 'image/jpeg') {
          _suffix = 'jpg';
        }
        var currentTime = (new Date()).getTime();
        var fileidNum = '' + currentTime + Math.floor(Math.random() * 10);
        //store.set('yanweiTime', currentTime);
        var fd = new FormData();
        // var _blob = dataURItoBlob(_data);
        fd.append('image', _blob, "file_" + Date.parse(new Date()) + ".jpg");
        fd.append('file', _blob, "file_" + Date.parse(new Date()) + ".jpg");
        fd.append('fileid', fileidNum);
        fd.append('addrssx', that.addrssx);
        fd.append('adcode', that.adcode);
        fd.append('company', that.antiCompany);//蜜蜂在线为1
        //				fd.append('big', "1");
        return callback(fd);
      })

    },
    skip: function () {

    },
    detail: function () {

    },
    result: function () {

    },
    success: function () {

    },
    fail: function () { }
  }
}
</script>

<style lang="scss" scoped>
.main {
  //position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  color: #595757;
  //background: #fff;
  overflow-y: hidden;

  h1 {
    text-align: center;
    font-size: 24px;
    margin: 50px auto;
  }

  .pz {
    text-align: center;
    position: relative;
    //top: 50%;
    //transform: translateY(-50%);

    .take,
    .wait {
      img {
        width: 6.513333rem;
      }
    }

    .take {
      .select {
        position: relative;
        width: 6.513333rem;
        height: 6.513333rem;
        margin: 0 auto;

        img {}

        input {
          position: absolute;
          left: 0;
          top: 0;
          width: 6.513333rem;
          height: 6.513333rem;
          opacity: 0;
        }
      }

      p {
        margin-top: 0.933333rem;
      }
    }

    .wait {
      p {
        margin-bottom: 0.933333rem;
      }
    }
  }

  .hidden {
    display: none;
  }

  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 60px;
    font-size: 16px;
    display: flex;
    width: 100%;
    line-height: 60px;
    background: #fff;

    a {
      flex: 1;
      text-align: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/example02/mainxw.vue